// =============================================================================
// useDateLocale - Hook per ottenere il locale date-fns dalla lingua corrente
// =============================================================================

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { it, enUS } from 'date-fns/locale';
import type { Locale } from 'date-fns';

const localeMap: Record<string, Locale> = {
  it,
  en: enUS,
};

export function useDateLocale(): Locale {
  const { i18n } = useTranslation();
  return useMemo(() => localeMap[i18n.language] ?? it, [i18n.language]);
}

export function getDateLocale(lang: string): Locale {
  return localeMap[lang] ?? it;
}
